import { AlphaBscTradingCard } from "@/components/domain/AlphaBscTradingCard";

export default function AlphaBscManualPage() {
  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-2xl font-semibold">Manual trading</h1>
        <p className="text-sm text-muted">
          Real on-chain swaps via PancakeSwap V3 + Uniswap V3 (BSC).
          Default size $25/trade, max $100/day, 2% max slippage. Hard
          ceilings: $100/trade, $500/day. Tokens NOT in your watchlist
          are not tradeable here — add them on the Watchlist tab first.
        </p>
      </header>
      <AlphaBscTradingCard />
    </div>
  );
}
